import {InstancedMesh} from 'three';
import {Object3D} from 'three';
import {BufferGeometry} from 'three';
import {Float32BufferAttribute} from 'three';
import {Points} from 'three';
import {PointsMaterial} from 'three';
import CloudsPointMaterial from '../materials/CloudsPointMaterial';

export default class CloudsSystem extends Points
{
  constructor(scene)
  {
    let map;
    let points 
    const vertices = [];
    const offset = [];
    let indexX = 0;
    let indexY = 0;
    scene.traverse ((child) => {

      if(child.material)
      {
        if (map === undefined) {
          map = child.material.map;
        }

        vertices.push(
          (child.position.x + Math.random()) * 300 * Math.random(),
          (child.position.z + Math.random()) * 300 * Math.random(),
          -400 - 400 * Math.random());
        offset.push(indexX++ % 2 / 2, indexY++ % 3 / 5);
      }
    })

    const geometry = new BufferGeometry();
    geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
    geometry.setAttribute( 'offset', new Float32BufferAttribute( offset, 2 ) );
    map.flipY = true;
    geometry.verticesNeedUpdate = true;
    geometry.computeBoundingSphere();

    const cloudMaterial = new CloudsPointMaterial(map);
    super(geometry, cloudMaterial)
    this.frustumCulled = false;

    this.geometry.verticesNeedUpdate = true; setTimeout(function(){ geometry.boundingSphere.radius = 100000;/*set to whatever is nessisary, this is just an example*/ },200)

    scene.parent.add(this);
    scene.parent.remove(scene);
  }
  
  update () {
    this.rotation.z += 0.0001; 
  }
}